export default __webpack_public_path__ + "static/media/Subscribed_Tick.97c095fe.svg";